import { createAsyncThunk } from '@reduxjs/toolkit';
import { sendWhatsAppAttachment } from 'services/whatsAppMessaging';
import { IWhatsAppMessage } from 'services/whatsAppMessaging/types';

interface IPayload {
  chatId: string;
  file: FormData;
  fileType: string;
}

export const ThunkSendWhatsAppAttachment = createAsyncThunk<IWhatsAppMessage, IPayload>(
  'whatsAppMessaging/sendAttachment',
  async payload => {
    const r = await sendWhatsAppAttachment(
      payload.chatId,
      payload.file,
      payload.fileType,
    );
    return r.data;
  },
);
